import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * `text-data` (13px) and `text-micro` (11px) are custom font sizes from our
 * @theme block. Without registering them, tailwind-merge reads them as colours
 * and silently drops `text-ink-muted` when both are present.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['data', 'micro'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
